import type {State} from 'src/reducers';
import {AuthenticationStatus} from 'src/reducers/authentication';
import type {ApiErrorWithStatusCode} from 'src/types/authentication';

import type {Agency} from 'src/types/agency';


export const selectMfaCredsValidating = (state: State): boolean =>
  state.authentication?.credAuthenticationStatus ===
  AuthenticationStatus.AUTHENTICATING;

export const selectMfaCredsError = (state: State): boolean =>
  state.authentication?.credAuthenticationStatus === AuthenticationStatus.ERROR;

export const selectMfaAuthChannel = (state: State): string =>
  state.authentication?.authenticationData?.mfa_settings?.auth_channel;

export const selectUserPhoneNumber = (state: State): string =>
  state.authentication?.authenticationData?.mfa_settings?.phone_number;

export const selectUserLoginId = (state: State): string =>
  state.authentication?.authenticationData?.login_id;

export const selectUserEmail = (state: State): string =>
  state.authentication?.authenticationData?.mfa_settings?.email_id;

export const selectUserNewPhoneNumber = (state: State): string =>
  state.authentication?.newPhone;

export const selectCurrentAgency = (state: State): Agency =>
  state.authentication?.authenticationData?.agency;

export const selectSignInError = (state: State): string | null | undefined =>
  state.authentication?.signInError;

export const selectRetryInMins = (state: State): number =>
  state.authentication?.retryInMins;

export const selectOtpVerificationError = (
  state: State,
): ApiErrorWithStatusCode => state.authentication?.otpVerificationError;

export const selectNewPhoneRegistrationError = (state: State): string =>
  state.authentication?.newPhoneRegistrationError;

export const selectResendOtpError = (state: State): string =>
  state.authentication?.resendOTPError;

export const selectResetMfaDeviceError = (state: State): string =>
  state.authentication?.resetMfaDeviceError;

export const selectResetPhoneApproveError = (state: State): string =>
  state.authentication?.resetPhoneApproveError;

export const selectResetPhoneApproved = (state: State): string =>
  state.authentication?.resetPhoneApproved;

export const selectValidAgencies = (
  state: State,
): Agency[] | null | undefined => state.authentication?.validAgencies;

export const selectForgotPasswordError = (state: State): string =>
  state.authentication?.forgotPasswordError;

export const selectResetPasswordError = (state: State): string =>
  state.authentication?.resetPasswordError;

export const selectSignUpError = (state: State): string =>
  state.authentication?.signUpError;

export const selectOtpLimitExceeded = (state: State): boolean =>
  state.authentication?.otpLimitExceeded;

export const selectTotpDetails = (state: State): boolean =>
  state.authentication.authenticationData?.mfa_settings?.totp_details;

export const selectShouldEnrollTotp = (state: State): boolean =>
  state.authentication.authenticationData?.mfa_settings?.should_enroll_totp;

export const selectResetTotpApproveError = (state: State): string =>
  state.authentication?.resetTotpApproveError;

export const selectResetTotpApproved = (state: State): string =>
  state.authentication?.resetTotpApproved;

export const selectChannelSelectionTotpError = (state: State): string =>
  state.authentication?.channelSelectionTotpError;
